import { render, staticRenderFns } from "./IconShipping.vue?vue&type=template&id=514e78a7"
import script from "./IconShipping.vue?vue&type=script&lang=js"
export * from "./IconShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports